import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/homepage.css'; // Import for gradient-text-animated class

import kalyanImage from '../../images/kalyan.webp';
import dhanyaImage from '../../images/dhanya.webp';
import siriImage from '../../images/siri.webp';

const OurTeam = () => {
  const navigate = useNavigate();

  const teamMembers = [
    {
      id: 1,
      name: "Kalyan Saladi",
      role: "Full Stack Developer",
      bio: "Passionate about building innovative developer tools and creating seamless user experiences.",
      image: kalyanImage,
      initials: "KS",
      specialties: ["React", "Node.js", "Cloud Architecture"],
      linkedin: "https://www.linkedin.com/in/-kalyan-saladi-",
      github: "https://github.com/kalyan-saladi"
    },
    {
      id: 2,
      name: "Dhanya Nayak",
      role: "Full Stack Developer",
      bio: "Full-stack developer with expertise in modern web technologies and collaborative development solutions.",
      image: dhanyaImage,
      initials: "DN",
      specialties: ["JavaScript", "UI/UX", "React"],
      linkedin: "https://www.linkedin.com/in/dhanya-nayak-5b4763283/",
      github: "https://github.com/DhanyaNayak04"
    },
    {
      id: 3,
      name: "Siri Ananth",
      role: "Full Stack Developer",
      bio: "Software engineer focused on creating robust and scalable development environments.",
      image: siriImage,
      initials: "SA",
      specialties: ["Database design", "React", "API Development"],
      linkedin: "https://www.linkedin.com/in/siri-ananth-452496157/",
      github: "https://github.com/siri2704"
    }
  ];

  return (
    <div className="team-page-creative">
      <div className="team-container-creative">
        {/* Hero Section */}
        <div className="team-hero-creative">
          <div className="hero-background-creative">
            <div className="floating-shapes">
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
            </div>
            <div className="gradient-overlay"></div>
          </div>
          
          <div className="team-badge-creative">
            <div className="badge-icon">
              <i className="fas fa-users"></i>
            </div>
            <span>Meet Our Team</span>
          </div>
          
          <h1 className="team-title-creative gradient-text-animated">
            The Innovators Behind
            <span className="highlight-text"> DevRoom</span>
          </h1>
          
          <p className="team-subtitle-creative">
            Passionate developers crafting the future of collaborative development environments
          </p>
        </div>

        {/* Team Members Grid */}
        <div className="team-section-creative">
          <div className="team-members-grid-creative">
            {teamMembers.map((member, index) => (
              <div key={member.id} className={`team-member-card-creative card-${index + 1}`}>
                <div className="card-background-effect">
                  <div className="gradient-border"></div>
                  <div className="glow-effect"></div>
                </div>
                
                {/* Profile Section */}
                <div className="member-profile-creative">
                  <div className="avatar-container-creative">
                    <div className="avatar-ring"></div>
                    <div className="avatar-inner">
                      <img 
                        src={member.image} 
                        alt={member.name}
                        className="avatar-image-creative"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      <div className="avatar-fallback-creative">
                        <span className="avatar-initials-creative">{member.initials}</span>
                      </div>
                    </div>
                   
                  </div>
                  
                  <div className="member-info-creative">
                    <h3 className="member-name-creative">{member.name}</h3>
                    <p className="member-role-creative">{member.role}</p>
                  </div>
                </div>
                
                {/* Bio Section */}
                <div className="member-bio-creative">
                  <p>{member.bio}</p>
                </div>
                
                {/* Specialties */}
                <div className="specialties-section-creative">
                  <div className="specialties-header">
                    <i className="fas fa-code"></i>
                    <span>Expertise</span>
                  </div>
                  <div className="specialty-tags-creative">
                    {member.specialties.map((specialty, idx) => (
                      <span key={idx} className="specialty-tag-creative">{specialty}</span>
                    ))}
                  </div>
                </div>
                
                {/* Social Links */}
                <div className="member-social-creative">
                  {member.linkedin && (
                    <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="social-link-creative linkedin">
                      <div className="link-background"></div>
                      <i className="fab fa-linkedin-in"></i>
                      <span className="tooltip">LinkedIn</span>
                    </a>
                  )}
                  {member.github && (
                    <a href={member.github} target="_blank" rel="noopener noreferrer" className="social-link-creative github">
                      <div className="link-background"></div>
                      <i className="fab fa-github"></i>
                      <span className="tooltip">GitHub</span>
                    </a>
                  )}
                </div>
                
                {/* Hover Effect */}
                <div className="card-hover-effect"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
